import React from 'react';
import classNames from 'classnames';
import { FetchResult } from '@apollo/client';
import { faComment } from '@fortawesome/free-solid-svg-icons/faComment';
import { faThumbsUp } from '@fortawesome/free-solid-svg-icons/faThumbsUp';
import { faReply } from '@fortawesome/free-solid-svg-icons/faReply';

import FlagComment from '@buyside/components/presentation/ShowPageComments/FlagComment/flagComment';
import Button, { BUTTON_SIZES, BUTTON_TYPES } from '@buyside/components/presentation/Button/button';

import { useIsMobile } from '@buyside/util/hooks/useIsMobile';

import { LikeCommentMutation } from '@interfaces/graphql-typings';

import styles from './commentActionsStyles.scss';

const CommentActions: React.FC<{
  commentId: string;
  currentUserHasLiked: boolean;
  hasChildComments: boolean;
  likeComment: () => Promise<FetchResult<LikeCommentMutation>>;
  likeCount: number;
  likeLoading: boolean;
  showChildComments: boolean;
  toggleReply: () => void;
  toggleShowChildComments: () => void;
  canWriteComments: boolean;
}> = ({
  canWriteComments,
  hasChildComments,
  commentId,
  currentUserHasLiked,
  likeComment,
  likeCount,
  likeLoading,
  showChildComments,
  toggleReply,
  toggleShowChildComments
}) => {
  const isMobile = useIsMobile();

  return (
    <div className={styles.actionsArea}>
      <Button
        analyticsTag="like"
        faIcon={faThumbsUp}
        isLoading={likeLoading}
        onClick={likeComment}
        className={classNames(
          currentUserHasLiked ? styles.actionButton : styles.actionButtonGhost,
          { [styles.liked]: currentUserHasLiked }
        )}
        text={
          isMobile ? `${likeCount}` : `${currentUserHasLiked ? 'Liked' : 'Like'} (${likeCount})`
        }
        type={BUTTON_TYPES.SECONDARY}
        size={BUTTON_SIZES.TINY}
      />
      {canWriteComments && (
        <Button
          className={styles.actionButton}
          onClick={toggleReply}
          faIcon={faReply}
          text="Reply"
          type={BUTTON_TYPES.SECONDARY}
          size={BUTTON_SIZES.TINY}
        />
      )}
      <div className={styles.rightActions}>
        {hasChildComments && (
          <Button
            className={showChildComments ? styles.actionButtonGhost : styles.actionButton}
            faIcon={faComment}
            onClick={toggleShowChildComments}
            text={showChildComments ? 'Hide Replies' : 'Show Replies'}
            type={BUTTON_TYPES.SECONDARY}
            size={BUTTON_SIZES.TINY}
          />
        )}
        <FlagComment commentId={commentId} />
      </div>
    </div>
  );
};

export default CommentActions;
